import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { parseDateValue } from "../../classes/utils/DateUtils";
import { GET_WEIGHTS_BY_IDS } from "../../queries/weightQueries";

export function useWeightsData(weightIds) {
  const { data, loading, error, refetch } = useQuery(GET_WEIGHTS_BY_IDS, {
    variables: { ids: weightIds },
    skip: !weightIds?.length,
    fetchPolicy: "network-only",
  });

  const weights = useMemo(() => {
    return data?.weightsByIds || [];
  }, [data]);

  const weightsByDate = useMemo(() => {
    // Create a copy of the array before sorting (most recent first)
    return [...weights].sort(
      (a, b) =>
        (parseDateValue(b.date)?.getTime() ?? 0) -
        (parseDateValue(a.date)?.getTime() ?? 0)
    );
  }, [weights]);

  const latestWeight = useMemo(() => {
    return weightsByDate[0] || null;
  }, [weightsByDate]);

  const currentWeightValue = useMemo(() => {
    return latestWeight?.value || null;
  }, [latestWeight]);

  return {
    weights,
    weightsByDate,
    latestWeight,
    currentWeightValue,
    loading,
    error,
    refreshWeights: refetch,
  };
}
